import { USER_FORM as userForm } from './userForm';

export const REGISTER = {
  userForm
};
